module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main download"
  }, [_c('div', {
    staticClass: "banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "home-part"
  }, [_c('div', {
    staticClass: "small-screen"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('home-download-title1')))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('img', {
    staticClass: "multi-device",
    attrs: {
      "src": require("../assets/images/20180815/mockup.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-download"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('home-download-title1')))]), _vm._v(" "), _c('div', {
    staticClass: "home-download-tip"
  }, [_c('p', {
    staticClass: "first"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/Checkmark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('home-download-title2')))])]), _vm._v(" "), _c('p', {
    staticClass: "second"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/Checkmark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('home-download-title3')))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "third"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/Checkmark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('home-download-title4')))])]), _vm._v(" "), _c('p', {
    staticClass: "four"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/Checkmark.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('home-download-title8')))])])]), _vm._v(" "), _c('div', {
    staticClass: "home-download-ways"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "home-download-others"
  }, [_c('div', {
    staticClass: "gotoWeb",
    on: {
      "click": _vm.gotoWeb
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/computer.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('home-download-title5')))])]), _vm._v(" "), _c('div', {
    staticClass: "gotoPC",
    on: {
      "click": _vm.gotoPC
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/download.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('home-download-title6')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tryCrait"
  }, [_c('a', {
    attrs: {
      "href": "https://dl.craitcorp.com/"
    }
  }, [_vm._v(_vm._s(_vm.$t('home-download-title7')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-download-qrcode"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180815/QRCode.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d60cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Download.vue
// module id = 294
// module chunks = 1